export const ADD_COURSE_DETAILS = "addcoursedetails";
export const ADD_CURRICULUM = "addcurriculumdetails";
export const ADD_STAGE = "addstage";
export const ADD_LECTURE = "addlecture";
